import React, { FC } from "react";
import { SectionRenderers, SectionRenderersV2 } from "@ldp/view-resolver-lite";

/** Don't forget to add prop types */
export interface IViewResolverSectionProps {
  /** The API version to use */
  apiVersion?: "v1" | "v2";
  /** Layout section to use */
  layoutSection: string;
  /** has footer section */
  hasFooter?: boolean;
}

/** Component to render a layout section based on the api version being used */
export const ViewResolverSection: FC<IViewResolverSectionProps> = ({
  layoutSection,
  apiVersion = "v1",
  hasFooter = false,
}) => {
  if (apiVersion === "v2") {
    return (
      <SectionRenderersV2
        layoutSection={layoutSection}
        isFooterSection={hasFooter}
      />
    );
  }
  return <SectionRenderers layoutSection={layoutSection} />;
};

export default ViewResolverSection;
